import useProjectStore from "common/store/ProjectStore";
import React, { FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import useLookupsStore from "common/store/LookupsStore";
import { DistanceUnit } from "common/store/ProjectStore";

interface IProps {
  plotImageTransform: number;
}

const PlotScale: FC<IProps> = ({ plotImageTransform }) => {
  const { scalingFactor, distanceID, zoomPercent } = useProjectStore();
  const { distances } = useLookupsStore();

  const [scaleX, setScaleX] = useState<number>(0);
  const [measurementUnit, setMeasurementUnit] = useState<string>('');
  const [unitWidth, setUnitWidth] = useState<number>(0);
  const [distanceLength, setDistanceLength] = useState<number>(100);

  useEffect(() => {
    var boxElement = document.getElementById("plot-plan-view-port");
    if(boxElement) {
      var box = boxElement.getBoundingClientRect();
      var viewPortWidth = box.right - box.left; 
      if(scaleX !== 0 && scaleX > (viewPortWidth * 0.6)) { // won't be greater than 2/3
        setDistanceLength(distanceLength/2);
      } else if ( scaleX !== 0 && scaleX < (viewPortWidth / 6)) { // won't be less than 1/6
        setDistanceLength(distanceLength*2);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoomPercent, scaleX]); //can't trigger on distanceLength

  // calculate the plot scale length
  useEffect(() => {
    if (scalingFactor && scalingFactor > 0) {
      setScaleX(scalingFactor * plotImageTransform * (zoomPercent / 100) * distanceLength);
    }
  }, [scalingFactor, plotImageTransform, zoomPercent, distanceLength]);

  useEffect(() => {
    const unit = distances.find(d => d.distanceID === distanceID);
    if (unit !== undefined) {
      setMeasurementUnit(unit.distanceName);
      if(unit.distanceID === DistanceUnit.Feet) {
        setUnitWidth(48);
      } else {
        setUnitWidth(64);
      }
    }
  }, [distanceID, distances])

  return (
    <Box sx={{ width: "100%", height: "20px", display: 'flex', justifyContent: "flex-end", alignItems: "flex-start" }} id="plot-scale-box">
      <Box
        sx={{
          bgcolor: "transparent",
          height: "20px",
          width: scaleX + 10 + unitWidth,
          zIndex: "2",
          userSelect: "none",
        }}
      >
        <Typography variant="caption" display="inline" paddingBottom={"5px"}>
          {distanceLength} {measurementUnit}
        </Typography>
        <svg height="100%" width={scaleX + 5}>
          <line x1={5} y1={12} x2={scaleX + 4} y2={12} stroke="black" />
          <line x1={5} y1={12} x2={5} y2={5} stroke="black" />
          <line x1={scaleX + 4} y1={12} x2={scaleX + 4} y2={5} stroke="black" />
        </svg>
      </Box>
    </Box>
  );
};

export default PlotScale;
